import { styled } from "styled-components";
import { useEffect } from "react";
import { Colors } from "../constants";
import { motion } from "framer-motion";

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  @media (min-width: 801px) {
    display: none;
  }
`;

const TabContainer = styled(motion.div)`
  flex: 1;
  text-align: center;
  font-family: "Space Grotesk", sans-serif;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 14px;
  line-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${Colors.Tan};
  height: 32px;
  cursor: pointer;
`;

const TabName = styled.div`
  background: ${(props) =>
    props.active === "true" ? `${Colors.Red}` : `${Colors.Tan}`};
  color: ${(props) =>
    props.active === "true" ? `${Colors.Tan}` : `${Colors.Brown}`};
  padding: 8px 12px;
  border-radius: 12px;
`;

const TabVariants = {
  initial: {
    scale: 1,
  },
  whileHover: {
    scale: 1.05,
  },
  whileTap: {
    scale: 0.95,
  },
  transition: { type: "ease-out", duration: 0.125 },
};

const Tab = ({ children, onClick, active }) => {
  return (
    <TabContainer
      // variants={TabVariants}
      // initial={"initial"}
      // whileHover="whileHover"
      // whileTap="whileTap"
      // transition="transition"
      onClick={onClick}
    >
      <TabName active={active.toString()}>{children}</TabName>
    </TabContainer>
  );
};

const TabBar = ({ currentTab, setCurrentTab }) => {
  return (
    <Wrapper>
      <Tab
        active={currentTab === "bio" ? true : false}
        onClick={() => setCurrentTab("bio")}
      >
        Bio
      </Tab>
      <Tab
        active={currentTab === "stats" ? true : false}
        onClick={() => setCurrentTab("stats")}
      >
        Stats
      </Tab>
      <Tab
        active={currentTab === "actions" ? true : false}
        onClick={() => setCurrentTab("actions")}
      >
        Actions
      </Tab>
    </Wrapper>
  );
};

export default TabBar;
